"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardSetClient = void 0;
const sdk_contants_1 = require("../../constants/sdk.contants");
const serializers_1 = require("../serializers");
const retryable_1 = require("./retryable");
class StandardSetClient {
    static newInstance(options, retryOptions) {
        return new StandardSetClient(retryable_1.RetryableHttpClient.newInstance(options, retryOptions), new serializers_1.StandardSetSerializer());
    }
    constructor(client, standardSetSerializer) {
        this.client = client;
        this.standardSetSerializer = standardSetSerializer;
    }
    async findAll(filter, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets`, {
            headers,
            params: { globalId: filter.globalIds },
        });
        return response.body.data.map((standardSet) => this.standardSetSerializer.serializeOne(standardSet));
    }
    async getStandardSetSubjects(standardSetId, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets/${standardSetId}/subjects`, {
            headers,
        });
        return response.body.data.map((subject) => this.standardSetSerializer.serializeSubject(subject));
    }
    async getStandardSetCourse(standardSetId, subject, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets/${standardSetId}/courses`, {
            headers,
            params: { subject: subject },
        });
        return response.body.data.map((course) => this.standardSetSerializer.serializeCourse(course));
    }
    async getStandardSetHierarchy(standardSetId, subjectId, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets/${standardSetId}/subject/${subjectId}/hierarchy`, {
            headers,
        });
        return response.body.data.map((hierarchy) => this.standardSetSerializer.serializeHierarchy(hierarchy));
    }
    async getStandardSetHierarchyByLevel(standardSetId, subjectId, level, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets/${standardSetId}/subject/${subjectId}/hierarchyLevel`, {
            headers,
            params: { level: level },
        });
        return this.standardSetSerializer.serializeHierarchyLevel(response.body.data);
    }
    async updateStandardSetHierarchy(standardSetId, subjectId, level, newLevel, headers) {
        const response = await this.client.put(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets/${standardSetId}/subject/${subjectId}/hierarchy`, { level: level, newLevel: newLevel }, {
            headers,
        });
        return response.body.data.map(() => { });
    }
    async deleteStandardSetHierarchy(standardSetId, subjectId, level, headers) {
        const response = await this.client.delete(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets/${standardSetId}/hierarchy/subject/${subjectId}/delete`, {
            headers,
            params: { level: level },
        });
        return response.body.data.map(() => { });
    }
    async findMe(headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets/me`, {
            headers,
        });
        return response.body.data.map((standardSet) => this.standardSetSerializer.serializeOne(standardSet));
    }
    async getSearchStandardsSet(filter, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets/search`, {
            headers,
            params: filter,
        });
        return this.standardSetSerializer.serializeStandardSetSearch(response.body.data);
    }
    async getOneStandardSet(standardSetId, visibility, headers) {
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets/${standardSetId}`, {
            headers,
            params: { visibility: visibility },
        });
        return this.standardSetSerializer.serializeOne(response.body.data);
    }
    async updateStandardSetById(standardSetId, updateStandardsSetDto, headers) {
        const response = await this.client.put(`${sdk_contants_1.ENGINE_API_PREFIX}/standardSets/${standardSetId}`, updateStandardsSetDto, {
            headers,
        });
        return this.standardSetSerializer.serializeOne(response.body.data);
    }
}
exports.StandardSetClient = StandardSetClient;
//# sourceMappingURL=standard-set.client.js.map